export function TeacherDashboard() {
  return (
    <div className="stack">
      <div><h1>Dashboard Guru</h1><p className="muted">Prioritaskan murid yang membutuhkan perhatian.</p></div>
      <section className="grid grid--3">
        <div className="metric"><span>Aktif hari ini</span><strong>32</strong></div>
        <div className="metric"><span>Perlu review</span><strong>4</strong></div>
        <div className="metric"><span>Level-up candidate</span><strong>3</strong></div>
      </section>
      <section className="card"><h2>Aksi cepat</h2><button className="btn btn--primary" type="button">Buat PR</button> <button className="btn" type="button">Scan QR</button></section>
    </div>
  );
}
